import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as placeService from '../../services/place';
import actions from './actions';
import toastr from 'toastr';
import {history} from "../../index";

export function* allPlaces({ payload }) {
  const { countryId } = payload;

  yield put({
    type: 'place/SET_STATE',
    payload: {
      loadingAll: true,
    },
  });

  const response = yield call(placeService.all, countryId);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'place/SET_STATE',
      payload: {
        all: data.data
      },
    })
  }

  yield put({
    type: 'place/SET_STATE',
    payload: {
      loadingAll: false,
    },
  })
}

export function* list({ payload }) {
  const { countryId, page, sorting, filter } = payload;

  yield put({
    type: 'place/SET_STATE',
    payload: {
      loadingList: true,
    },
  });

  const response = yield call(placeService.list, countryId, page, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'place/SET_STATE',
      payload: {
        list: data.data,
        meta: data.meta
      },
    })
  }

  yield put({
    type: 'place/SET_STATE',
    payload: {
      loadingList: false,
    },
  })
}

export function* details({ payload }) {
  const { countryId, id } = payload;

  yield put({
    type: 'place/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(placeService.details, countryId, id);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'place/SET_STATE',
      payload: {
        details: data.data
      },
    })
  }

  yield put({
    type: 'place/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* add({ payload }) {
  const response = yield call(placeService.add, payload);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push(`/country/${payload.countryId}/places`);
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'place/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* edit({ payload }) {
  const { countryId, id, data } = payload;

  const response = yield call(placeService.edit, countryId, id, data);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push(`/country/${countryId}/places`);
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'place/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* remove({ payload }) {
  const { countryId, id, page } = payload;

  const response = yield call(placeService.remove, countryId, id);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });

    return yield call(list.bind(null, { payload: { countryId, page: page ?? 1}}));
  }

  if (response && response.status >= 400 && response.status <= 422) {
    toastr.error(response.data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
  }
}

export function* refreshErrors() {
  yield put({
    type: 'place/SET_STATE',
    payload: {
      errors: {},
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.REFRESH_ERRORS, refreshErrors),
    takeEvery(actions.ALL, allPlaces),
    takeEvery(actions.FETCH_ALL, list),
    takeEvery(actions.DETAILS, details),
    takeEvery(actions.ADD, add),
    takeEvery(actions.EDIT, edit),
    takeEvery(actions.REMOVE, remove)
  ])
}
